import React from "react";

/**
 * Simple context used to force re-evaluation of warning messages
 * whenever profile/onboarding dialogs update underlying data.
 *
 * Components that render field-level warnings (e.g. `QuestionGroup`)
 * read this value and pass it into `useFieldWarnings` as a
 * `refreshKey`, which is included only in the hook's memo deps.
 *
 * The value itself is never inspected – we just bump the number to
 * invalidate memoized warning results.
 */
export const WarningsRefreshContext =
  React.createContext<number>(0);

export const useWarningsRefreshKey = (): number =>
  React.useContext(WarningsRefreshContext);


